import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import EncryptPage from './pages/EncryptPage';
import ExtractPage from './pages/ExtractPage';
import AboutModal from './components/AboutModal';
import SupportModal from './components/SupportModal';
import './styles/main.css';

// Главный компонент: фронтенд‑only инструмент (без аутентификации и сети)
const App = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
  const [showAbout, setShowAbout] = useState(false);
  const [showSupport, setShowSupport] = useState(false);

  useEffect(() => {
    document.body.dataset.theme = theme;
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => (prev === 'light' ? 'dark' : 'light'));

  return (
    <Router>
      <div className="app">
        <Navbar
          theme={theme}
          onToggleTheme={toggleTheme}
          onOpenAbout={() => setShowAbout(true)}
          onOpenSupport={() => setShowSupport(true)}
        />
        <div className="app-container">
          <Routes>
            <Route path="/" element={<Navigate to="/encrypt" replace />} />
            <Route path="/encrypt" element={<EncryptPage />} />
            <Route path="/extract" element={<ExtractPage />} />
            <Route path="*" element={<Navigate to="/encrypt" replace />} />
          </Routes>
        </div>
        <AboutModal isOpen={showAbout} onClose={() => setShowAbout(false)} />
        <SupportModal isOpen={showSupport} onClose={() => setShowSupport(false)} />
      </div>
    </Router>
  );
};

export default App;
